/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            let handle = button.dataset.collection;
            [].forEach.call(this.buttons, function(el) {
              el.classList.remove('active');
            });

            button.classList.add('active');

            if (handle) {
              // PFQ perf (v9): товары вкладки могли ещё не догрузиться — сначала догрузить
              this.pfqEnsure(handle).then(() => this.toggleCollection(handle));
            }

            event.preventDefault();
          });
        });
      }, 20);
      // PFQ perf (v9): остальные вкладки догружаются после загрузки страницы
      const pfqPreload = () => {
        (window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); })(() => {
          Array.from(this.querySelectorAll('button[data-collection]')).forEach((b) => this.pfqEnsure(b.dataset.collection));
        });
      };
      if (document.readyState === 'complete') { setTimeout(pfqPreload, 2000); } else { window.addEventListener('load', () => setTimeout(pfqPreload, 2000)); }
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }
    pfqEnsure(handle) {
      const slider = document.getElementById(this.dataset.target);
      if (!slider || !handle || handle.indexOf('collection-') === 0 || slider.querySelector(`[data-collection="${handle}"]`)) {
        return Promise.resolve();
      }
      this.pfqCache = this.pfqCache || {};
      if (!this.pfqCache[handle]) {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        this.pfqCache[handle] = fetch(`${root}collections/${handle}?section_id=pfq-tab-cards`)
          .then((r) => r.text())
          .then((html) => {
            // template, а не DOMParser: иначе картинки из <noscript> становятся настоящими и качаются в 1280 px
            const tpl = document.createElement('template');
            tpl.innerHTML = html;
            tpl.content.querySelectorAll('noscript').forEach((n) => n.remove());
            tpl.content.querySelectorAll('.columns[data-collection]').forEach((el) => slider.append(document.importNode(el, true)));
          })
          .catch(() => {});
      }
      return this.pfqCache[handle];
    }
    toggleCollection(handle) {
      let slider = document.getElementById(this.target),
        products = slider.querySelectorAll(`.columns:not([data-collection*="${handle}"])`),
        active_products = slider.querySelectorAll(`[data-collection*="${handle}"]`),
        flkty = Flickity.data(slider);
      [].forEach.call(products, function(el) {
        el.classList.remove('carousel__slide');
        slider.append(el);
      });
      [].forEach.call(active_products, function(el) {
        if (el.dataset.collection === handle) {
          el.classList.add('carousel__slide');
        } else {
          el.classList.remove('carousel__slide');
          slider.append(el);
        }
      });
      flkty.insert(active_products);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
